import { Injectable } from "@angular/core";
import { Actions, createEffect, ofType } from "@ngrx/effects";
import { catchError, map, switchMap } from "rxjs/operators";
import { DateProviderService } from "src/app/_services/date-provider.service";
import { DateProviderActionTypes } from "src/app/constants/StoreConstants";
import { GetDateProviderError, GetDateProviderSuccess } from "./date-provider.actions";
import { of } from "rxjs";

@Injectable()
export class DateProviderEffects {
  constructor(
    private actions$: Actions,
    private dateProviderService: DateProviderService
  ) {}

    public getDateProvider$ = createEffect(() => {
        return this.actions$.pipe(
            ofType(DateProviderActionTypes.GetDateProvider),
            switchMap(()=>{
                return this.dateProviderService.getDateProvider$()
                .pipe(
                    map((dateProvider)=>{
                        return GetDateProviderSuccess({ dateProvider: dateProvider});
                    }),
                    catchError((error: any) => {
                        return of(GetDateProviderError({ error: error }));
                    })
                )
            })
        );
    });
}